import { PromiseResponse } from '@types';
import { SSOTokenRawData } from 'features/onlinePayment/state/iclinic-pay/types';
import { apiOnlinePayment } from '..';

export const fetchSSOToken = (): PromiseResponse<SSOTokenRawData> =>
  apiOnlinePayment.get('/sellers/sso-token-generate/');
